export interface BiteSidebarQuote {symbol:string;price?:number|null;changePercent:number|null;prePost?:{phase:'pre'|'post';changePercent:number|null}|null}
export function biteSidebarSymbols(tickers:string[]) {
 return [...new Set(tickers.flatMap(ticker=>/^\d{6}$/.test(ticker)?[`${ticker}.KS`,`${ticker}.KQ`]:[ticker]))].sort();
}
export function biteSidebarChange(quotes:BiteSidebarQuote[],ticker:string) {
 const quote=quotes.find(q=>q.symbol===ticker)||quotes.find(q=>q.symbol===`${ticker}.KS`&&Number.isFinite(q.changePercent))||quotes.find(q=>q.symbol===`${ticker}.KQ`);
 const value=quote?.prePost?.changePercent??quote?.changePercent;
 return typeof value==='number'&&Number.isFinite(value)?value:null;
}
export function biteSidebarPercent(value:number|null) {
 return value==null?'확인 중':`${value>0?'+':''}${value.toFixed(2)}%`;
}
